module.exports = __webpack_public_path__ + "img/deposit-icon.bdd3bcca.svg";